module.exports = __webpack_public_path__ + "static/img/case3.66641eaf.jpg";